import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const useScrollReset = (): null => {
  const location = useLocation();

  // eslint-disable-next-line modernloop/no-use-effect.cjs -- Effect synchronizes browser or analytics APIs after render.
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return null;
};
